import { withParams } from 'vuelidate/lib/validators/common'
import { countCodePoints } from '@/support/utils/unicodeText'

export default (max) => withParams(
  {
    type: 'maxLength',
    max
  },
  value => value === null || value === undefined || value === '' || countCodePoints(value) <= max
)
